// Free gift bar in the cart drawer: an "Add Free" button for a single
// product/variant that only unlocks once the cart reaches the free
// shipping threshold. The theme cannot make a real Shopify line item
// free on its own — that price override is handled server-side by a
// Discount Function matching the `_free_gift` line item property this
// file sets. Without that function installed, the item adds at its
// normal price.
//
// Because the cart drawer's HTML gets replaced wholesale on every cart
// change (custom-atc.js, cart.js), the button and bar are found fresh
// each time via delegated listeners rather than bound once.
(function () {
  'use strict';

  var FREE_GIFT_PROPERTY = '_free_gift';
  var removalInFlight = false;

  function getBar() {
    return document.querySelector('[data-free-gift-bar]');
  }

  function sections() {
    return ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];
  }

  function applySections(sectionData, openDrawer) {
    if (window.customATCManager && typeof window.customATCManager.updateCartSectionsFromData === 'function') {
      window.customATCManager.updateCartSectionsFromData(sectionData, openDrawer);
      return;
    }

    if (!sectionData || !sectionData['cart-drawer']) return;
    var target = document.querySelector('#CartDrawer');
    if (!target) return;
    var doc = new DOMParser().parseFromString(sectionData['cart-drawer'], 'text/html');
    var source = doc.querySelector('#CartDrawer');
    if (source) target.innerHTML = source.innerHTML;
  }

  function announceCartChange() {
    document.dispatchEvent(new CustomEvent('custom-cart-update'));
    window.dispatchEvent(new CustomEvent('custom-atc-updated'));
    if (window.customATCManager && typeof window.customATCManager.refreshCartData === 'function') {
      window.customATCManager.refreshCartData(true);
    }
  }

  /* ------------------------------------------------------------------ *
   * Adding the gift
   * ------------------------------------------------------------------ */

  function handleAddClick(event) {
    var button = event.target.closest('[data-free-gift-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var bar = button.closest('[data-free-gift-bar]');
    var variantId = bar && bar.dataset.freeGiftVariantId;
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');

    var properties = {};
    properties[FREE_GIFT_PROPERTY] = 'true';
    try {
      var giftDoctorId = localStorage.getItem('doctor_id');
      if (giftDoctorId) properties.doctorId = giftDoctorId;
    } catch (e) {}

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: properties }],
        sections: sections(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error('Error adding free gift:', response);
          button.disabled = false;
          button.classList.remove('is-loading');
          return;
        }

        applySections(response.sections, true);
        announceCartChange();
      })
      .catch(function (error) {
        console.error('Error adding free gift:', error);
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  /* ------------------------------------------------------------------ *
   * Auto-removing the gift if the cart drops back below the threshold
   * ------------------------------------------------------------------ */

  function findFreeGiftLine(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (
        item.variant_id === variantId &&
        item.properties &&
        item.properties[FREE_GIFT_PROPERTY] === 'true'
      ) {
        return item;
      }
    }
    return null;
  }

  function removeFreeGiftLine(lineKey) {
    if (removalInFlight) return;
    removalInFlight = true;

    fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: sections(), sections_url: window.location.pathname }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        applySections(response.sections, false);
        announceCartChange();
      })
      .catch(function (error) {
        console.error('Error removing free gift:', error);
      })
      .finally(function () {
        removalInFlight = false;
      });
  }

  function checkThreshold(cart) {
    var bar = getBar();
    if (!bar) return;

    var variantId = parseInt(bar.dataset.freeGiftVariantId, 10);
    var threshold = parseInt(bar.dataset.freeGiftThreshold, 10);
    if (!variantId || !threshold) return;

    var line = findFreeGiftLine(cart, variantId);
    if (!line) return;

    if (cart.total_price < threshold) {
      removeFreeGiftLine(line.key);
    }
  }

  function fetchCartAndCheck() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(checkThreshold)
      .catch(function () {});
  }

  function handleCartEvent(event) {
    if (removalInFlight) return;
    var cart = event && event.detail && (event.detail.cart || event.detail.cartData);
    if (cart && Array.isArray(cart.items)) {
      checkThreshold(cart);
      return;
    }
    fetchCartAndCheck();
  }

  /* ------------------------------------------------------------------ *
   * Wiring
   * ------------------------------------------------------------------ */

  document.addEventListener('click', handleAddClick);

  window.addEventListener('animeal:cart:changed', handleCartEvent);
  window.addEventListener('animeal:cart:state', handleCartEvent);
  document.addEventListener('cart:updated', handleCartEvent);
  document.addEventListener('custom-cart-update', function () {
    fetchCartAndCheck();
  });
  if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      handleCartEvent({ detail: event });
    });
  }
})();
